﻿import m from "mithril";
import DateUtilities from "../../shared/utilities/date_utilities";
import i18n from "../../shared/i18n/i18n";

const Modal_Unit_File_History = {
    view: function (vnode) {
        return [
            m(".form-section", [
                vnode.attrs.history && vnode.attrs.history.length > 0 ? [
                    m(".table-wrapper flex-auto", [
                        m("table.full-width", [
                            m("thead",
                                m("tr", [
                                    m("th", i18n.t("version")),
                                    m("th", i18n.t("date")),
                                    m("th", i18n.t("file_name")),
                                    vnode.attrs.metadataTitle ? m("th", vnode.attrs.metadataTitle) : "",
                                    m("th", i18n.t("uploaded_by"))
                                ])
                            ),
                            m("tbody", vnode.attrs.history.map(function (record, index) {
                                return [
                                    m("tr", [
                                        m("td", index + 1),
                                        m("td", DateUtilities.getFormattedDate(record.creationDate)),
                                        m("td", record.fileName),
                                        vnode.attrs.metadataTitle ? m("td", record.metadata) : "",
                                        m("td", record.uploaderName)
                                    ])
                                ];
                            }))
                        ])
                    ])
                ] : m(".text-gray padding", i18n.t("no_records"))
            ])
        ];
    }
};
export default Modal_Unit_File_History;
